<script lang="ts">
	import { Breadcrumb, BreadcrumbItem } from "$lib/components/molecules/Breadcrumb";
	import { Contents } from "$lib/components/organisms/Listing";
	import { HeroThematic } from "$lib/components/organisms/Hero";
	import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
	import type { IListingPage, IListingPageTemplateWithImage } from "$lib/utils/contentful/types";
	import type { IFilters } from "$lib/utils/filters/types";
	import type { CourseModel } from "@24hbs/utils";

  export let listingPage: IListingPage;
  export let listingPageFilters: IFilters | null = null;
  export let courses: CourseModel[] = [];
  export let totalCourses: number = 0;
  export let highlightedItems: CourseModel[] = [];

  const listingPageTemplate = listingPage.fields.template as IListingPageTemplateWithImage;

  let heroData;

  $: heroData = {
      image: listingPageTemplate.fields.heroImage?.fields.file?.url || '',
      srcset: listingPageTemplate.fields.heroImage?.fields.file?.url || '',
      imageAlt: listingPageTemplate.fields.heroImage?.fields.description || '',
      name:  listingPageTemplate.fields.heroBadgeLabel,
      quote: listingPageTemplate.fields.heroTitle,
      text: documentToHtmlString(listingPageTemplate.fields.heroDescription),
  };
</script>

<Breadcrumb disableLastElementLink>
  <BreadcrumbItem>
      <a href="/">Home</a>
  </BreadcrumbItem>
  <BreadcrumbItem current>
      <a href={`/${listingPage.fields.slug}`}>{listingPage.fields.title}</a>
  </BreadcrumbItem>
</Breadcrumb>

<HeroThematic
  image={listingPageTemplate.fields.heroImage?.fields.file}
  thematic={{
      image: heroData.image,
      srcset: heroData.srcset,
      imageAlt: heroData.imageAlt,
      name: heroData.name,
      quote: heroData.quote
  }}
>
  {@html heroData.text}
</HeroThematic>

<Contents
  {listingPage}
  preloadCourses={courses}
  preloadedTotalCourses={totalCourses}
  {listingPageFilters}
  {highlightedItems}
/>